var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"topx"},[_c('div',{staticClass:"center"},[_c('div',{staticClass:"bt"},[_vm._v("亦源智能停车管理统计平台")]),_c('div',{staticClass:"time"},[_vm._v(_vm._s(_vm.time))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }